import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Template } from '../../../components/template'
import { MaxWidth } from '../../../components/max-width'
import { SummaryCard } from '../simulation/components/SummaryCard'
import { FaqDrawer } from '../../../components/faq-drawer'
import { useNegotiationPaymentSuccess } from '../hooks'
import {
  PageContainer,
  PageGrid,
  SuccessCard,
  HeaderBadge,
  HeaderIcon,
  HeaderText,
  ContentWrapper,
  SectionTitle,
  SectionSubtitle,
  InfoBanner,
  InfoIconWrapper,
  InfoContent,
  InfoText,
  ActionButton
} from './styles'
import { getCrid } from '../helpers'

export const NegotiationPaymentSuccess = () => {
  const history = useHistory()
  const crid = getCrid()
  const { formattedData, isLoading } = useNegotiationPaymentSuccess(crid)

  // Redirect se não houver dados de pagamento
  useEffect(() => {
    if (!isLoading && !formattedData) {
      history.push('/dashboard/negociacao/pagamento')
    }
  }, [isLoading, formattedData, history])

  const handleGoToDashboard = () => {
    history.push('/dashboard')
  }

  if (isLoading || !formattedData) {
    return (
      <Template>
        <FaqDrawer />
        <PageContainer>
          <MaxWidth>
            <SuccessCard>
              <ContentWrapper>
                <SectionTitle>Carregando...</SectionTitle>
              </ContentWrapper>
            </SuccessCard>
          </MaxWidth>
        </PageContainer>
      </Template>
    )
  }

  // Determinar tipo de pagamento
  const isCashPayment = formattedData.tipoPagamento === 'avista'

  // Título e descrição condicionais
  const title = isCashPayment ? 'Acordo concluído com sucesso!' : 'Pagamento de entrada confirmado com sucesso!'

  const description = isCashPayment
    ? 'Seu pagamento já foi confirmado e o acordo quitado com sucesso.'
    : 'Seu acordo foi iniciado, e as próximas parcelas deverão ser pagas até as respectivas datas de vencimento. Mantenha seus pagamentos em dia para garantir a continuidade e validade do acordo.'

  // PaymentPlan condicional para SummaryCard
  const paymentPlan = isCashPayment
    ? [
        {
          id: 'total-cash',
          label: 'Total à vista',
          type: 'text',
          value: formattedData.totalAVista,
          highlight: true
        }
      ]
    : [
        { id: 'entry', label: 'Entrada', type: 'text', value: formattedData.valorEntrada },
        {
          id: 'installments',
          label: 'Parcelas',
          type: 'text',
          value:
            formattedData.quantidadeParcelas && formattedData.valorParcela
              ? `${formattedData.quantidadeParcelas}x de ${formattedData.valorParcela}`
              : '-'
        },
        {
          id: 'total',
          label: 'Total pago a prazo',
          type: 'text',
          value: formattedData.totalPagoAPrazo,
          highlight: true
        }
      ]

  // Schedule condicional para SummaryCard
  const schedule = isCashPayment
    ? [{ id: 'payment-due', label: 'Venc. do pagamento', date: formattedData.dataVencimentoPagamento }]
    : [
        { id: 'entry-due', label: 'Venc. da entrada', date: formattedData.dataVencimentoEntrada },
        { id: 'first-due', label: 'Venc. 1ª parcela', date: formattedData.dataVencimentoPrimeiraParcela }
      ]

  return (
    <Template>
      <FaqDrawer />
      <PageContainer>
        <MaxWidth>
          <PageGrid>
            <SuccessCard>
              <HeaderBadge>
                <HeaderIcon>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM10.8036 16.8L19.2876 8.31491L17.5908 6.61817L10.8036 13.4062L7.40878 10.0114L5.71204 11.7081L10.8036 16.8Z"
                      fill="white"
                    />
                  </svg>
                </HeaderIcon>
                <HeaderText>Pagamento Confirmado</HeaderText>
              </HeaderBadge>

              <ContentWrapper>
                <div>
                  <SectionTitle>{title}</SectionTitle>
                  <SectionSubtitle>{description}</SectionSubtitle>
                </div>

                <InfoBanner>
                  <InfoIconWrapper>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9 9V15H11V9H9ZM9 5V7H11V5H9Z"
                        fill="#0088CC"
                      />
                    </svg>
                  </InfoIconWrapper>
                  <InfoContent>
                    <InfoText>O comprovante de pagamento foi enviado para o seu e-mail cadastrado.</InfoText>
                  </InfoContent>
                </InfoBanner>

                <ActionButton onClick={handleGoToDashboard}>Voltar para o painel do aluno</ActionButton>
              </ContentWrapper>
            </SuccessCard>

            <SummaryCard
              variant="completed"
              showDiscount={false}
              isLoading={isLoading}
              outstanding={{
                currentValue: formattedData.saldoDevedorAtual,
                previousValue: formattedData.saldoDevedorAnterior
              }}
              calculation={formattedData.calculation}
              paymentPlan={paymentPlan}
              schedule={schedule}
            />
          </PageGrid>
        </MaxWidth>
      </PageContainer>
    </Template>
  )
}
